"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnDescriptionDialog = exports.InheritedRowDetails = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var Datasource14pxSmall_1 = require("../../../gen-src/icons/Datasource14pxSmall");
var DatasourceCertified14pxSmall_1 = require("../../../gen-src/icons/DatasourceCertified14pxSmall");
var Table14pxSmall_1 = require("../../../gen-src/icons/Table14pxSmall");
var TableCertified14pxSmall_1 = require("../../../gen-src/icons/TableCertified14pxSmall");
var SharedDialogTelemetry_1 = require("../telemetry/SharedDialogTelemetry");
var TelemetryContext_1 = require("../telemetry/TelemetryContext");
var TelemetrySender_1 = require("../telemetry/TelemetrySender");
var ColumnDescriptionDialogStyles_1 = require("./ColumnDescriptionDialogStyles");
function InheritedRowDetails(props) {
    if (props.value == null) {
        return null;
    }
    return (React.createElement(ColumnDescriptionDialogStyles_1.InheritedRow, null,
        React.createElement(ColumnDescriptionDialogStyles_1.InheritedDetailsLabel, null,
            props.label,
            " ",
            props.icon || null),
        React.createElement(ColumnDescriptionDialogStyles_1.InheritedDetailsValue, null, props.value)));
}
exports.InheritedRowDetails = InheritedRowDetails;
var ColumnDescriptionDialog = /** @class */ (function (_super) {
    __extends(ColumnDescriptionDialog, _super);
    function ColumnDescriptionDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayStartTime = Date.now();
        _this.sentDialogClosedTelemetry = false;
        _this.sendDialogClosedTelemetry = function () {
            if (_this.sentDialogClosedTelemetry) {
                return;
            }
            var displayEndTime = Date.now();
            var displayDuration = displayEndTime - _this.displayStartTime;
            var typeOfDataDisplayed = 'column-description';
            var telemetryEnvironment = TelemetryContext_1.getTelemetryEnvironmentEnumValueFromString(_this.props.telemetryEnvironment);
            var dialogReleaseVersion = _this.props.tableauVersion;
            var siteLuid = _this.props.siteLuid;
            var telemetryContext = {
                telemetryEnvironment: telemetryEnvironment,
                dialogReleaseVersion: dialogReleaseVersion,
                siteLuid: siteLuid,
            };
            if (_this.props.telemetryContractApi) {
                TelemetrySender_1.telemetrySender.setTelemetryContractApiCallback(_this.props.telemetryContractApi);
                SharedDialogTelemetry_1.sharedDialogTelemetry.sendDataDisplayedInSharedDialog(typeOfDataDisplayed, displayDuration, telemetryContext);
            }
            _this.sentDialogClosedTelemetry = true;
        };
        _this.onClose = function () {
            _this.sendDialogClosedTelemetry();
            _this.props.onClose();
        };
        return _this;
    }
    ColumnDescriptionDialog.prototype.componentWillUnmount = function () {
        this.sendDialogClosedTelemetry();
    };
    ColumnDescriptionDialog.prototype.render = function () {
        var shouldShowInheritedDetails = !!this.props.inheritedColumnName || !!this.props.assetParent;
        return (React.createElement(widgets_1.DialogWidget, { anchorEl: this.props.anchorEl, anchorOrigin: {
                vertical: widgets_1.VerticalOriginOption.top,
                horizontal: widgets_1.HorizontalOriginOption.right,
            }, dialogBodyStyle: ColumnDescriptionDialogStyles_1.DescriptionDialogBodyStyle, dialogWidth: ColumnDescriptionDialogStyles_1.dialogWidth, disableAutoFocus: true, isModal: false, onCloseRequest: this.onClose, positioningBehavior: widgets_1.DialogPositioningBehavior.Anchored, showCloseButton: false, showFooter: false, testId: 'column-description', type: widgets_1.DialogType.Uber },
            React.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionPane, null,
                React.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionFieldName, null, this.props.fieldName),
                React.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionCell, null,
                    React.createElement(ColumnDescriptionDialogStyles_1.DescriptionLabel, null, Localize_1.Messages.Description()),
                    React.createElement(ColumnDescriptionDialogStyles_1.DescriptionText, null, this.props.description)),
                shouldShowInheritedDetails && this.renderInheritanceDetails())));
    };
    ColumnDescriptionDialog.prototype.renderInheritanceDetails = function () {
        return (React.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionCell, null,
            !!this.props.inheritedColumnName && (React.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionInheritedColumnRow, null,
                React.createElement(InheritedRowDetails, { label: Localize_1.Messages.DescriptionInheritanceColumnLabel(), value: this.props.inheritedColumnName }))),
            !!this.props.assetParent && this.renderAssetParent()));
    };
    ColumnDescriptionDialog.prototype.renderAssetParent = function () {
        var label = null;
        var icon;
        switch (this.props.assetParent.contentType) {
            case 'datasource':
                label = Localize_1.Messages.DescriptionInheritanceDatasourceLabel();
                icon = this.props.assetParent.isCertified ? (React.createElement(DatasourceCertified14pxSmall_1.SvgDatasourceCertified14pxSmall, { style: {
                        padding: '0 3px',
                        verticalAlign: 'top',
                    } })) : (React.createElement(Datasource14pxSmall_1.SvgDatasource14pxSmall, { style: {
                        padding: '0 3px',
                        verticalAlign: 'top',
                    } }));
                break;
            case 'table':
                label = Localize_1.Messages.DescriptionInheritanceTableLabel();
                icon = this.props.assetParent.isCertified ? (React.createElement(TableCertified14pxSmall_1.SvgTableCertified14pxSmall, { style: ColumnDescriptionDialogStyles_1.AssetParentIconStyle })) : (React.createElement(Table14pxSmall_1.SvgTable14pxSmall, { style: ColumnDescriptionDialogStyles_1.AssetParentIconStyle }));
                break;
            default:
                return;
        }
        return (React.createElement(ColumnDescriptionDialogStyles_1.ColumnDescriptionInheritedColumnRow, null,
            React.createElement(InheritedRowDetails, { label: label, value: this.props.assetParent.name, icon: icon })));
    };
    return ColumnDescriptionDialog;
}(React.Component));
exports.ColumnDescriptionDialog = ColumnDescriptionDialog;
//# sourceMappingURL=ColumnDescriptionDialog.js.map